<template>
  <div>
    <manage-inventory-sidebar
        :ref="addEditItemSidebarlId"
        :item-id="addEditItemSidebarlId"
        :profile="profile"
        :root-path-doc="rootPathDoc"
        :root-data-doc="rootDataDoc"
        @item-added="handleItemAdded"
    />
    <display-preview-sidebar
        :ref="displayPreviewSidebarId"
        :item-id="displayPreviewSidebarId"
        :profile="profile"
        @item-added="handleItemAdded"
    />
    <b-row>
      <b-col>
        <b-link @click="handleEditClick">
          Manage Inventory
        </b-link>
      </b-col>
      <b-col>
        <b-link @click="handleShowDisplay">
          Preview
        </b-link>
      </b-col>
      <b-col>
        <b-link @click="handleShowDisplay">
          Scan Items
        </b-link>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ManageInventorySidebar from "@/components/_services/warehouse/manageInventorySidebar";
import DisplayPreviewSidebar from "@/components/_services/warehouse/displayPreviewSidebar";
import VideoHandling from "@/mixins/VideoHandling";
import UploadImage from "@/mixins/UploadImage";
import moment from "moment";
import firebase from "firebase";

export default {
  name: "ManageTab_Warehouse",
  mixins: [UploadImage, VideoHandling],
  components: {
    ManageInventorySidebar,
    DisplayPreviewSidebar
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleActivation() {
     if (!this.unsub){
       this.setUpSnapShot();
     }
    },
    setUpSnapShot() {
      //@ToDo =- move to store
      debugger
      if (this.rootPathDoc) {
        const db = firebase.firestore();
        let docRef = db.doc(this.rootPathDoc);
        this.unsub = docRef.onSnapshot(snapshot => {
          this.rootDataDoc = snapshot.data();
        });
      }
    },
    handleEditClick(item) {;
      //Crew //Available Tools //MyApps //Website
      if (this.$refs[this.addEditItemSidebarlId].hasOwnProperty("handleUpdateItem")) {
        this.$refs[this.addEditItemSidebarlId].handleUpdateItem(item);
      }
    },
    handleShowDisplay(item) {;
      //Crew //Available Tools //MyApps //Website
      if (this.$refs[this.displayPreviewSidebarId].hasOwnProperty("handleUpdateItem")) {
        this.$refs[this.displayPreviewSidebarId].handleUpdateItem(item);
      }
    },
    handleItemAdded(item) {
      debugger
      this.$store.dispatch("user/showNotification", {
        title: `A Provider Added ${item && item.name ? item.name : ""} !'}`,
        description: `Your item has been added`,
        variant: "success"
      });
      this.getProviders();
    }
  },
  data() {
    return {
      rootPathDoc: `providers/${this.provider.id}/lists/__warehouse`,
      rootDataDoc: null,
      v2: false,
      unsub: null,
      addEditItemSidebarlId: "add-edit-item-sidebar-warehouse",
      displayPreviewSidebarId: "display-preview-warehouse",
    };
  }
};
</script>

<style lang="scss" scoped>
</style>